import { makeStyles } from '@mui/styles';
const styles = makeStyles(({ breakpoints }) => {
  return {
    customTool: {
      marginLeft: '13px',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      cursor: 'pointer',
      marginTop: '10px'
    },
    disableImportLabel: {
      fontWeight: 700,
      fontSize: '0.875rem',
      cursor: 'pointer',
      pointerEvents: 'none',
      color: 'rgba(0, 0, 0, 0.26)'
    },
    featuredWrapperListParam: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      maxWidth: '1450px',
      margin: '25px auto',
      textAlign: 'center',
      flexDirection: 'row',

      [breakpoints.down(500)]: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }
    },
    fullWidthSeparator: {
      top: '15px',
      width: '100vw',
      height: '5px',
      backgroundColor: '#F1F1F0',
      position: 'relative',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    chartGrid: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    },
    chartTypesSelect: {
      padding: '10px',
      maxWidth: '2560px',
      width: '100%',
      position: 'relative',
      [breakpoints.down(500)]: {
        justifyContent: 'flex-start',
        padding: '0px',
        paddingBottom: '10px',
        whiteSpace: 'nowrap',
        overflowX: 'auto',
        flexWrap: 'nowrap',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollMarginTop: '90px'
      }
    },
    active: {
      color: '#38b6FF',
      fontWeight: 'bold',
      textDecoration: 'underline',
      [breakpoints.down(500)]: {
        fontSize: '16px',
        padding: '0px',
        margin: '0px'
      }
    },
    inactive: {
      color: '#bbbbbb',
      fontWeight: 'bold',
      [breakpoints.down(500)]: {
        fontSize: '16px',
        padding: '0px',
        margin: '0px'
      }
    },
    dialogModal: {
      '& .MuiPaper-root': {
        marginLeft: '10px',
        '& .makeStyles-dialogTitle-37': {
          padding: '16px 12px !important',
        },
        maxWidth: '1200px',
      },
      '& .MuiTypography-subtitle1': {
        fontSize: '1.3rem',
        fontWeight: 'bold',
      }
    },
    disableIcon: {
      pointerEvents: 'none',
      color: 'rgba(0, 0, 0, 0.26)'
    },
    importLabel: {
      fontWeight: 700,
      fontSize: '0.875rem',
      cursor: 'pointer',
    },
    invalidRow: {
      backgroundColor: '#ffcccc !important'
    },
    accordianBorderDisplay: {
      '&:before': {
        display: 'none',
      },
      boxShadow: 'none',
      '&.Mui-expanded': {
        margin: '0px',
      },
    },
    accordianSummary: {
      fontSize: '20px',
      fontWeight: 'bold',
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: '0px',
        marginTop: '10px'
      },
      '&.Mui-expanded': {
        minHeight: '0px',
      },
    },
    mobileDrawer: {
      width: '100vw',
      height: '100vh',
    },

    mobileDrawerHeader: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '8px',
    },
  };
});
export default styles;
